import { useQuery, useQueryClient } from '@tanstack/react-query'
import { IUseEducationMode } from 'api/types/education-mode'
import { QUERY_KEY } from 'app/constants'
import { useLocalStorage } from 'lib/hooks/use-local-storage'
import { useCallback, useEffect, useMemo } from 'react'

export const useEducationMode = (): IUseEducationMode => {
  const queryClient = useQueryClient()
  const [educationModeLocalStorage, setEducationModeLocalStorage] =
    useLocalStorage('educationMode', false)

  const { data, isError } = useQuery({
    queryKey: [QUERY_KEY.educationMode],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: educationModeLocalStorage as boolean,
  })

  useEffect(() => {
    if (!data || isError) setEducationModeLocalStorage(false)
    else setEducationModeLocalStorage(data)
  }, [isError, data, setEducationModeLocalStorage])

  const disableEducationMode = useCallback(() => {
    return queryClient.setQueryData([QUERY_KEY.educationMode], false)
  }, [queryClient])

  return useMemo(() => {
    return {
      educationMode: data,
      disableEducationMode,
      isError,
    }
  }, [data, disableEducationMode, isError])
}
